var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29571 2.02152H8.1183C8.28598 2.02152 8.42207 1.90835 8.42207 1.76892V0.25333C8.42207 0.113896 8.28598 0.000732422 8.1183 0.000732422H6.29571C4.45368 0.000732422 2.95429 1.24705 2.95429 2.77931V4.5475H0.827935C0.660257 4.5475 0.52417 4.66066 0.52417 4.80009V6.31568C0.52417 6.45511 0.660257 6.56828 0.827935 6.56828H2.95429V11.8728C2.95429 12.0123 3.09038 12.1254 3.25806 12.1254H5.08065C5.24833 12.1254 5.38441 12.0123 5.38441 11.8728V6.56828H7.51077C7.64139 6.56828 7.75743 6.49856 7.79935 6.3955L8.40688 4.87991C8.43786 4.80312 8.42207 4.71825 8.36496 4.65207C8.30724 4.5864 8.21611 4.5475 8.1183 4.5475H5.38441V2.77931C5.38441 2.36151 5.79328 2.02152 6.29571 2.02152Z",
    fill: "#0A142F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.593c7ea195930b45976bd725115ab356.svg";
export { ForwardRef as ReactComponent };